// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1__ac6144129d2691b8c86f","cls2":"FocusedNav-cls2___28d0c67cfc9a61eb71f FocusedNav-cls1__ac6144129d2691b8c86f"};